var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIsraelFlag(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "country-flags",
    clipPath: "url(#clip0_2759_2516)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.5 24C19.1274 24 24.5 18.6274 24.5 12C24.5 5.37258 19.1274 0 12.5 0C5.87258 0 0.5 5.37258 0.5 12C0.5 18.6274 5.87258 24 12.5 24Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M17.0193 9.39128H14.0069L12.5008 6.78259L10.9948 9.39128H7.98242L9.4887 12L7.98242 14.6087H10.9948L12.5008 17.2173L14.0069 14.6087H17.0193L15.513 12L17.0193 9.39128ZM14.3512 12L13.4261 13.6025H11.5757L10.6505 12L11.5757 10.3974H13.4261L14.3512 12ZM12.5008 8.7948L12.8452 9.39123H12.1566L12.5008 8.7948ZM9.72519 10.3974H10.4139L10.0695 10.9938L9.72519 10.3974ZM9.72519 13.6025L10.0696 13.0061L10.4139 13.6025H9.72519ZM12.5008 15.2051L12.1565 14.6087H12.8452L12.5008 15.2051ZM15.2765 13.6025H14.5878L14.9322 13.0061L15.2765 13.6025ZM14.5878 10.3974H15.2765L14.9322 10.9938L14.5878 10.3974Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M19.9703 2.60864H5.03058C3.93544 3.48089 2.99625 4.54036 2.26172 5.73909H22.7392C22.0046 4.54041 21.0654 3.48089 19.9703 2.60864Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M5.03058 21.3913H19.9702C21.0654 20.519 22.0046 19.4595 22.7391 18.2608H2.26172C2.9963 19.4595 3.93548 20.519 5.03058 21.3913Z",
    fill: "#0052B4"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2759_2516"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIsraelFlag);
export default __webpack_public_path__ + "static/media/israel-flag.aaaf2b3dbd648c3ef480ae569ccd53b7.svg";
export { ForwardRef as ReactComponent };